import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider, createRouter } from '@tanstack/react-router';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { NewVersionBanner, RouteError } from './components/new-version-banner';
import './index.css';
import { installStaleBuildRecovery } from './lib/stale-build';
import { routeTree } from './routeTree.gen';

installStaleBuildRecovery();

const queryClient = new QueryClient({
  defaultOptions: { queries: { retry: 1, staleTime: 10_000 } },
});
const router = createRouter({
  routeTree,
  context: { queryClient },
  defaultPreload: 'intent',
  defaultErrorComponent: RouteError,
});

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={router} />
      <NewVersionBanner />
    </QueryClientProvider>
  </StrictMode>,
);
